(
    function (global, $, Si) {
        "use strict";

        sidePanelComponent();

        function sidePanelComponent() {

            Si.component('SidePanel', {
                initSidePanel: initSidePanel
            });

            var params = {
                class_active: 'side-panel-active',
                class_enabled: 'side-panel-enabled'
            };

            function initSidePanel(panelAnchorElement, containerElement, openerElement) {

                var panelOpener = $('.side-panel').find(openerElement); // get panel toggler

                panelOpener.on('click', function (e) { // change state on click
                    e.preventDefault();
                    containerElement.toggleClass(params.class_active);
                });

                checkSidePanel(); // Check panel visibility on page load

                $(window).on('scroll resize', function () { // Check panel visibility on resize
                    checkSidePanel();
                });

                function checkSidePanel() { // Sidebar visibility check
                    var trigger = 0,
                        windowScrollTop = $(window).scrollTop(),
                        windowHeight = $(window).height();

                    if (panelAnchorElement.length) {

                        trigger = panelAnchorElement.offset().top;

                        if (windowScrollTop + windowHeight - 0 >= trigger) {
                            showPanel();
                        }
                        else {
                            hidePanel();
                        }
                    }else{
                        showPanel();
                    }
                };

                function hidePanel() { // Hide side panel
                    containerElement.removeClass(params.class_enabled);
                    containerElement.removeClass(params.class_active);
                };

                function showPanel() { // Show side panel
                    containerElement.addClass(params.class_enabled);
                };
            }

        }
    }
)(window, jQuery, Si);
